import { activeLocale, negotiateLocale, type Locale } from './locale';

// Draft translations await native review, like the app catalogues. These stable
// launch messages live once so gateway and product errors use the same wording.
export const LAUNCH_CATALOGUES = {
  en: {
    'errors.sharing_off': "Sharing isn't available yet. You can keep using your own contacts and mail.",
    'errors.product_unavailable': "This app isn't available yet. You can keep using Mail and Contacts.",
    'launch.apps_off': 'Outside apps are unavailable during the private launch.',
  },
  nl: {
    'errors.sharing_off': 'Delen is nog niet beschikbaar. Je kunt je eigen contacten en e-mail blijven gebruiken.',
    'errors.product_unavailable': 'Deze app is nog niet beschikbaar. Je kunt Mail en Contacten blijven gebruiken.',
    'launch.apps_off': 'Externe apps zijn tijdens de besloten introductie niet beschikbaar.',
  },
  de: {
    'errors.sharing_off': 'Teilen ist noch nicht verfügbar. Du kannst deine eigenen Kontakte und E-Mails weiterhin nutzen.',
    'errors.product_unavailable': 'Diese App ist noch nicht verfügbar. Du kannst Mail und Kontakte weiterhin nutzen.',
    'launch.apps_off': 'Externe Apps sind während des geschlossenen Starts nicht verfügbar.',
  },
  fr: {
    'errors.sharing_off': 'Le partage n’est pas encore disponible. Vous pouvez continuer à utiliser vos propres contacts et e-mails.',
    'errors.product_unavailable': 'Cette application n’est pas encore disponible. Vous pouvez continuer à utiliser Mail et Contacts.',
    'launch.apps_off': 'Les applications externes ne sont pas disponibles pendant le lancement privé.',
  },
} as const satisfies Record<Locale, Record<string, string>>;
export type LaunchMessage = keyof typeof LAUNCH_CATALOGUES.en;

export function launchCatalogue(locale: string): Record<string, string> {
  return LAUNCH_CATALOGUES[negotiateLocale([locale]) as Locale];
}

export function launchMessage(key: LaunchMessage, locale: string = activeLocale()): string {
  return launchCatalogue(locale)[key] ?? LAUNCH_CATALOGUES.en[key];
}

export function errorMessage(error: { code?: string; message?: string }, fallback: string, locale: string = activeLocale()): string {
  if (error.code === 'sharing_off' || error.code === 'product_unavailable') return launchMessage(`errors.${error.code}`, locale);
  return error.message || fallback;
}
